export default class EitherOrPointsModel {
  public correctSteps: number = 0;
  public score: number = 0;
}
